import jwtRepository from '@/app/login/repository/jwtRepository'
import { createDeviceId } from '@/shared/lib'

// login
export const jwtSecret =
    'ZGVhZGJlZWYwMDAxMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDM='
export const deviceId = createDeviceId()
// export const deviceId = process.env.REACT_APP_GET_DEVICE_ID
export const loginToken = jwtRepository()
export const loginRouteCodespot = 'login'

// profile
export const getProfilesRoute = 'profiles'
export const setProfileRoute = 'profile'

// favorites
export const favoriteChannelsEndpoint = 'favoritechannels'
export const markFavoriteEndpoint = 'markfavorite'
export const unMarkFavoriteEndpoint = 'unmarkfavorite'

export const checkPINRoute = 'verifypin'
export const getConfigRoute = 'config'
export const getSearchResultsRoute = 'search'
export const maxRequestRetry = 6
export const getChannelsRoute = 'channels'
export const configLsKeyword = 'dottv:config'
export const epgEndpoint = 'epg'
